
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 2"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#e2e2e2"}},[_c('path',{attrs:{"d":"M13.5 1.5H.5v-1h13v1z"}}),_c('path',{attrs:{"d":"M14 2H0V0h14v2z","fill":"#727174"}})])])
          )
        }
      }
    